const BlogsIllustration: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="620"
      height="424"
      viewBox="0 0 620 424"
      fill="none"
      {...props}
    >
      <path
        d="M98.9336 245.672C98.9336 245.672 17.6736 246.154 87.4191 181.577C157.165 116.999 69.0836 123.386 95.7363 91.0708C122.389 58.7559 259.603 14.1411 280.666 43.1888C301.729 72.2365 264.756 120.288 264.756 120.288L507.094 79.7311C507.094 79.7311 519.524 106.749 533.216 113.415C546.907 120.081 531.622 134.919 525.663 158.127C519.704 181.334 509.927 209.614 542.676 230.938C575.424 252.261 631.999 301.396 525.663 302.649C419.328 303.902 475.463 334.439 449.838 338.103C424.213 341.768 373.32 341.361 331.791 365.383C290.261 389.406 241.125 353.168 212.764 362.533C184.403 371.898 110.58 384.07 152.503 307.345C194.425 230.62 98.9336 245.672 98.9336 245.672Z"
        fill="#C4F4F5"
      />
      <path
        d="M525.665 59.3359H226.406V293.405H525.665V59.3359Z"
        fill="#06AEB3"
      />
      <path
        d="M519.962 61.6953H228.83V285.328H519.962V61.6953Z"
        fill="white"
      />
      <path
        d="M323.416 129.656H251.217V142.459H323.416V129.656Z"
        fill="#027C80"
      />
      <path
        d="M345.346 152.914H251.217V155.398H345.346V152.914Z"
        fill="#06AEB3"
      />
      <path
        d="M340.223 161.539H251.217V164.023H340.223V161.539Z"
        fill="#06AEB3"
      />
      <path
        d="M345.346 170.5H251.217V172.984H345.346V170.5Z"
        fill="#06AEB3"
      />
      <path
        d="M325.339 195.953H253.141V204.348H325.339V195.953Z"
        fill="#027C80"
      />
      <path
        d="M438.583 213.508H270.246V215.992H438.583V213.508Z"
        fill="#06AEB3"
      />
      <path
        d="M429.422 222.133H270.246V224.617H429.422V222.133Z"
        fill="#06AEB3"
      />
      <path
        d="M438.583 231.086H270.246V233.57H438.583V231.086Z"
        fill="#06AEB3"
      />
      <path
        d="M438.583 129.656H349.834V197.054H438.583V129.656Z"
        fill="#FF7A33"
      />
      <path
        d="M475.517 129.656H449.838V136.507H475.517V129.656Z"
        fill="#027C80"
      />
      <path
        d="M495.904 141.141H449.838V144.234H495.904V141.141Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 148.852H449.838V151.945H495.904V148.852Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 156.586H449.838V159.679H495.904V156.586Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 164.305H449.838V167.398H495.904V164.305Z"
        fill="#02E5EB"
      />
      <path
        d="M475.517 185.477H449.838V192.327H475.517V185.477Z"
        fill="#027C80"
      />
      <path
        d="M495.904 196.953H449.838V200.047H495.904V196.953Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 204.688H449.838V207.781H495.904V204.688Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 212.398H449.838V215.492H495.904V212.398Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 220.125H449.838V223.218H495.904V220.125Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 227.844H449.838V230.937H495.904V227.844Z"
        fill="#02E5EB"
      />
      <path
        d="M495.904 235.57H449.838V238.664H495.904V235.57Z"
        fill="#02E5EB"
      />
      <path
        d="M248.189 83.2187C250.111 83.2187 251.669 81.6605 251.669 79.7383C251.669 77.8161 250.111 76.2578 248.189 76.2578C246.267 76.2578 244.709 77.8161 244.709 79.7383C244.709 81.6605 246.267 83.2187 248.189 83.2187Z"
        fill="#84EDF0"
      />
      <path
        d="M259.919 83.2187C261.841 83.2187 263.399 81.6605 263.399 79.7383C263.399 77.8161 261.841 76.2578 259.919 76.2578C257.997 76.2578 256.439 77.8161 256.439 79.7383C256.439 81.6605 257.997 83.2187 259.919 83.2187Z"
        fill="#84EDF0"
      />
      <path
        d="M271.65 83.2187C273.572 83.2187 275.13 81.6605 275.13 79.7383C275.13 77.8161 273.572 76.2578 271.65 76.2578C269.728 76.2578 268.17 77.8161 268.17 79.7383C268.17 81.6605 269.728 83.2187 271.65 83.2187Z"
        fill="#84EDF0"
      />
      <path
        d="M475.517 93.1875H284.678V107.229H475.517V93.1875Z"
        fill="#F0FEFF"
      />
      <path
        d="M490.591 104.072C493.161 104.072 495.244 101.989 495.244 99.419C495.244 96.849 493.161 94.7656 490.591 94.7656C488.021 94.7656 485.938 96.849 485.938 99.419C485.938 101.989 488.021 104.072 490.591 104.072Z"
        stroke="#027C80"
        strokeWidth="0.725482"
        strokeMiterlimit="10"
      />
      <path
        d="M494.232 102.305L497.575 105.647"
        stroke="#027C80"
        strokeWidth="0.725482"
        strokeMiterlimit="10"
      />
      <path
        d="M255.706 95.75L251.217 100.24L255.645 104.669"
        stroke="#027C80"
        strokeWidth="0.725482"
        strokeMiterlimit="10"
      />
      <path
        d="M266.592 104.669L271.081 100.178L266.654 95.75"
        stroke="#027C80"
        strokeWidth="0.725482"
        strokeMiterlimit="10"
      />
      <path
        d="M182.182 151.602L150.07 168.597L142.383 195.127L160.088 212.462L167.691 209.924L180.572 191.229L187.37 165.735L187.727 158.4L182.182 151.602Z"
        fill="#FFD6BF"
      />
      <path
        d="M176.854 250.191L173.824 257.819L175.892 259.885L205.854 259.377L210.663 257.819L199.65 249.662L187.771 246.969L176.854 250.191Z"
        fill="#FFD6BF"
      />
      <path
        d="M235.529 365.131C235.529 365.131 235.744 370.06 244.315 371.852C252.887 373.644 247.892 378.055 247.892 378.055L225.36 377.311L223.826 372.236L223.82 365.961L227.167 359.242L235.529 365.131Z"
        fill="#FFD6BF"
      />
      <path
        d="M280.666 334.258C280.666 334.258 283.776 338.185 296.192 339.701C308.608 341.218 294.986 346.229 294.986 346.229L277.081 347.824L276.351 344.827C276.351 344.827 276.381 343.671 274.111 341.488C271.842 339.304 272.935 336.343 272.935 336.343L280.666 334.258Z"
        fill="#FFD6BF"
      />
      <path
        d="M153.617 170.384C153.617 170.384 153.398 191.382 146.813 194.675C146.813 194.675 129.4 196.284 121.645 212.454C121.645 212.454 99.8876 195.122 136.503 173.737C136.503 173.737 139.432 140.343 166.235 138.585C193.038 136.828 201.972 185.601 176.341 201.713C176.341 201.713 174.498 199.217 164.667 195.906C164.667 195.906 163.891 194.767 164.357 191.507C164.357 191.507 183.994 196.222 186.641 161.911C186.641 161.911 182.89 159.263 183.111 154.299C183.111 154.299 175.092 169.699 153.617 170.384Z"
        fill="#011919"
      />
      <path
        d="M165.219 305.484H169.299L167.855 383.589C167.849 383.914 167.584 384.175 167.259 384.175C166.934 384.175 166.669 383.914 166.663 383.589L165.219 305.484Z"
        fill="#FF5A01"
      />
      <path
        d="M126.109 307.352H130.19L128.746 385.457C128.74 385.782 128.475 386.042 128.15 386.042C127.825 386.042 127.56 385.782 127.554 385.457L126.109 307.352Z"
        fill="#FF5A01"
      />
      <path
        d="M114.243 278.594C114.243 278.594 112.698 294.064 121.982 302.382L123.644 301.865C123.644 301.865 114.136 292.126 115.925 278.867L114.243 278.594Z"
        fill="#FF5A01"
      />
      <path
        d="M161.34 312.692C185.42 312.692 204.942 309.468 204.942 305.49C204.942 301.513 185.42 298.289 161.34 298.289C137.259 298.289 117.738 301.513 117.738 305.49C117.738 309.468 137.259 312.692 161.34 312.692Z"
        fill="#FF7A33"
      />
      <path
        d="M135.042 275.41L118.563 278.644C118.563 278.644 112.822 280.477 106.103 273.758C99.3843 267.039 89.9782 247.86 100.362 235.522C105.614 229.78 118.16 227.81 118.16 227.81L140.551 225.016L142.384 266.673L135.042 275.41Z"
        fill="#FF7A33"
      />
      <path
        d="M196.076 305.484H200.157L198.713 383.589C198.707 383.914 198.442 384.175 198.117 384.175C197.792 384.175 197.526 383.914 197.52 383.589L196.076 305.484Z"
        fill="#FF7A33"
      />
      <path
        d="M150.551 310.914H154.632L153.187 389.019C153.181 389.344 152.916 389.604 152.591 389.604C152.266 389.604 152.001 389.344 151.995 389.019L150.551 310.914Z"
        fill="#FF7A33"
      />
      <path
        d="M178.39 251.472C178.39 251.472 189.468 248.339 195.735 249.275C202.007 250.216 208.322 258.147 208.322 258.147L219.071 257.556L193.751 245.307C193.751 245.307 186.214 208.403 178.579 202.854C171.129 197.446 164.668 195.903 164.668 195.903C164.668 195.903 169.887 201.481 166.516 204.552C158.522 211.852 145.377 195.117 145.377 195.117C138.203 195.505 131.689 199.342 125.344 206.642C114.644 218.958 117.909 249.59 119.378 254.81C120.853 260.029 136.777 258.821 136.777 258.821C136.913 265.379 136.108 271.404 136.108 271.404C146.682 277.69 152.503 272.078 152.503 272.078V259.917L201.318 259.887L201.036 258.548L204.088 258.322L199.606 255.756C187.989 257.885 175.358 257.953 175.358 257.953C176.508 252.724 178.39 251.472 178.39 251.472ZM131.888 245.055C131.888 245.055 132.058 240.728 133.348 237.585C133.348 237.585 135.147 241.965 135.652 245.671L131.888 245.055Z"
        fill="white"
      />
      <path
        d="M137.706 220.789L133.346 237.586C133.346 237.586 135.025 241.559 135.65 245.672L152.985 248.034C152.985 248.034 138.717 241.293 137.706 220.789Z"
        fill="#EDEDED"
      />
      <path
        d="M136.777 258.831H176.504C176.504 258.831 176.799 258.917 177.149 257.929C177.149 257.929 196.249 256.844 199.606 255.766C199.606 255.766 203.203 258.044 204.941 258.308L201.036 258.558L201.318 259.897H152.502V272.088C152.502 272.088 146.088 277.886 136.107 271.414C136.107 271.414 137.019 265.753 136.777 258.831Z"
        fill="#EDEDED"
      />
      <path
        d="M213.29 295.198C213.29 295.198 210.744 312.536 216.852 333.597C222.96 354.659 223.82 365.954 223.82 365.954C223.82 365.954 229.052 369.109 235.529 365.123C235.529 365.123 231.332 320.135 231.447 307.509C231.563 294.882 222.72 288.25 222.72 288.25L213.29 295.198Z"
        fill="#027C80"
      />
      <path
        d="M136.107 271.409C136.107 271.409 128.619 293.729 140.56 302.951C152.501 312.173 191.991 296.566 222.14 294.202C222.14 294.202 228.763 315.233 255.119 328.283C263.775 332.805 274.111 341.493 274.111 341.493C274.111 341.493 279.946 338.504 280.666 334.263C280.666 334.263 247.261 302.072 222.931 268.092C216.009 259.073 153.318 266.335 136.107 271.409Z"
        fill="#06AEB3"
      />
      <path
        d="M296.192 339.695C296.192 339.695 305.074 342.524 281.565 346.633C281.565 346.633 278.384 346.987 276.351 344.821C276.351 344.821 274.009 348.799 277.986 352.688L278.251 353.395C278.251 353.395 281.831 354.323 287.929 352.776L287.752 351.671C287.752 351.671 304.757 351.503 317.867 344.8C317.867 344.8 318.606 341.564 317.177 341.482C315.748 341.4 298.519 340.209 296.192 339.695Z"
        fill="#06AEB3"
      />
      <path
        d="M244.314 371.844C244.314 371.844 253.139 378.783 228.477 375.2C228.477 375.2 225.3 374.805 223.825 372.228C223.825 372.228 220.624 375.553 223.59 380.258L223.684 381.008C223.684 381.008 226.951 382.741 233.242 382.651C233.242 382.651 233.046 381.533 233.326 381.535C246.322 381.644 249.906 385.317 264.213 381.837C264.213 381.837 265.445 379.324 264.312 378.449C263.196 377.588 260.966 375.626 244.314 371.844Z"
        fill="#06AEB3"
      />
      <path
        d="M232.311 386.695H228.414L225.988 272.078H234.737L232.311 386.695Z"
        fill="#011919"
      />
      <path
        d="M308.221 259.898H152.502V272.091H308.221V259.898Z"
        fill="#011919"
      />
      <path
        d="M252.374 386.078H208.352V390.212H252.374V386.078Z"
        fill="#011919"
      />
      <path
        d="M280.665 259.893H250.732L265.284 202.117H295.217L280.665 259.893Z"
        fill="#FF7A33"
      />
      <path
        d="M201.037 259.895V258.558L251.774 255.766L250.734 259.895H201.037Z"
        fill="#FF5A01"
      />
      <path
        d="M467.45 350.987C470.074 350.987 472.202 348.86 472.202 346.236C472.202 343.612 470.074 341.484 467.45 341.484C464.826 341.484 462.699 343.612 462.699 346.236C462.699 348.86 464.826 350.987 467.45 350.987Z"
        fill="#C4F4F5"
      />
      <path
        d="M557.274 97.551C559.04 102.539 556.429 108.015 551.442 109.782C546.454 111.548 540.978 108.937 539.211 103.949C537.445 98.9615 537.265 86.6009 542.144 88.6487C548.252 91.2125 554.818 90.6199 557.274 97.551Z"
        fill="#C4F4F5"
      />
      <path
        d="M85.0291 72.4161C85.0291 72.4161 48.898 96.6897 75.0236 114.987C101.149 133.285 68.0753 138.288 47.5083 121.612C26.9414 104.935 26.6634 71.0264 53.6228 62.9661C80.5822 54.9059 100.593 63.522 85.0291 72.4161Z"
        fill="#C4F4F5"
      />
    </svg>
  );
};

export default BlogsIllustration;
